import { EmploymentNoteType } from './employment-note-type.interface';
import { EmploymentNoteTypeService } from './employment-note-type.service';

const service = new EmploymentNoteTypeService();

interface iEmploymentNoteTypesState {
   employmentNoteTypes: Array<EmploymentNoteType>;
}

const state: iEmploymentNoteTypesState = {
   employmentNoteTypes: [],
};

const mutations = {
   SET_EMPLOYMENT_NOTE_TYPES(state: iEmploymentNoteTypesState, employmentNoteTypes: Array<EmploymentNoteType>) {
      state.employmentNoteTypes = employmentNoteTypes;
   },
};

const actions = {
   async getEmploymentNoteTypes(context: any) {
      return await service.getEmployementNoteTypes().then((employmentNoteTypes) => {
         context.commit('SET_EMPLOYMENT_NOTE_TYPES', employmentNoteTypes);
         return employmentNoteTypes;
      });
   },
};

export default {
   namespaced: true,
   state,
   mutations,
   actions,
};
